import React from "react";
import PropTypes from "prop-types";
import { Icons } from "@learningblocks/exp-constants";
const { CorrectRelative: CorrectIcon, HexagonSolid: IconHexagon } = Icons;
import style from "./style.module.scss";

/**
 * IndexNumber:
 *  - To display the Menu Number in Notebook/MenuList/Menu
 */
export function IndexNumber(props) {
  const getClassName = (sub = "") =>
    `${style[`block${sub}`]} ${props.className + sub}`;

  return (
    <div className={getClassName()} aria-label={`Section: ${props.number}`}>
      <span className={getClassName("_icon")} aria-hidden={true}>
        <IconHexagon />
      </span>
      {props.visited ? (
        <CorrectIcon className={getClassName("_visited")} aria-hidden={true} />
      ) : (
        <p className={getClassName("_number")} aria-hidden={true}>
          {props.number}
        </p>
      )}
    </div>
  );
}

IndexNumber.propTypes = {
  /**
   * Index number
   */
  number: PropTypes.number,
  /**
   * Boolean set if Section visited
   */
  visited: PropTypes.bool,
};

IndexNumber.defaultProps = {
  number: undefined,
  visited: false,
};
